var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckedCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#FFF",
    strokeWidth: 1.5,
    cx: 9,
    cy: 9,
    r: 8.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33 13a.667.667 0 01-.471-.195L4.19 10.138a.666.666 0 01.943-.943l2.171 2.17 5.532-6.144a.667.667 0 01.992.892l-6.003 6.666a.669.669 0 01-.478.221H7.33z",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
}
export default SvgCheckedCircle;